module.exports = __webpack_public_path__ + "static/media/developer.054b8d05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/developer.svg
// module id = 1361
// module chunks = 0